import React from 'react';

// material ui icons
import FireplaceIcon from '@material-ui/icons/Fireplace';

// components
import Button from 'components/Button';
import ClassroomLinkList from './ClassroomLinkList';
import DazzlingDialog from 'components/DazzlingDialog';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function ClassroomLinksModal({ open, onClose }: Props) {
  return (
    <DazzlingDialog
      id='classroomLinksModal'
      open={open}
      handleClose={onClose}
      actions={[
        <Button color='primary' variant='contained' onClick={onClose}>
          Close
        </Button>,
      ]}
      isButtonOnTheRightCorner
      headerProps={{
        icon: FireplaceIcon,
        title: `Access your Phired Up Classroom`,
        highlightedSubtitle: `Access your organization's specific education classroom.`,
      }}
    >
      <ClassroomLinkList />
    </DazzlingDialog>
  );
}
